webpackJsonp([72334677858794],{

/***/ "./src/assets/curve-top.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTAyNHB4IiBoZWlnaHQ9IjM0NXB4IiB2aWV3Qm94PSIwIDAgMTAyNCAzNDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ1LjEgKDQzNTA0KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Db21iaW5lZCBTaGFwZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJJbml0aWFsLVJlbGVhc2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJIb21lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgLTQ1OC4wMDAwMDApIiBmaWxsPSIjRjRGOEZDIj4KICAgICAgICAgICAgPGcgaWQ9IlNlY3Rpb24tMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQxMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0tMy43MzAzNDkzNmUtMTQsMjY0LjA5Mzg0NyBMLTMuNzMwMzQ5MzZlLTE0LDEzNS40NDAzMTkgQzEzNS45NTgyNzEsODEuMDQ3ODAyOSAzMTUuMTQwMDY3LDQ4IDUxMS41LDQ4IEM3MDguMzQxNzMxLDQ4IDg4Ny45MjA5MjQsODEuMjEwMTc3MiAxMDI0LDEzNS44NDEwODUgTDEwMjQsMjY0LjI5NDIyOSBMMTAyNCwzOTIuNzQ3Mzc0IEwtMy43MzAzNDkzNmUtMTQsMzkyLjc0NzM3NCBMLTMuNzMwMzQ5MzZlLTE0LDI2NC4wOTM4NDcgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "./src/assets/feature-icon-placeholder.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTJweCIgaGVpZ2h0PSI1MnB4IiB2aWV3Qm94PSIwIDAgNTIgNTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjIgKDQ0NDk2KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5PdmFsIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iSW5pdGlhbC1SZWxlYXNlIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtZGFzaGFycmF5PSIxMCI+CiAgICAgICAgPGcgaWQ9IkhvbWUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MC4wMDAwMDAsIC05MzcuMDAwMDAwKSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNEREU1RUQiPgogICAgICAgICAgICA8ZyBpZD0iU2VjdGlvbi0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDEwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlF1b3RlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OS4wMDAwMDAsIDM4MS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLTIiIGN4PSIyNyIgY3k9IjE3MiIgcj0iMjUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "./src/assets/section-1.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/section-1.3b485650.png";

/***/ }),

/***/ "./src/components/feature-header-left.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _mainFeature, _grid, _circle, _frame, _normal, _info, _mainFeatureGraphic;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureHeaderLeft = function (_React$Component) {
	  _inherits(FeatureHeaderLeft, _React$Component);
	
	  function FeatureHeaderLeft() {
	    _classCallCheck(this, FeatureHeaderLeft);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  FeatureHeaderLeft.prototype.render = function render() {
	
	    var buttonText = [{ type: this.props.name[0].type, text: this.props.name[0].text.toLowerCase() }];
	
	    return Glamor.createElement(
	      "div",
	      { css: styles.mainFeature },
	      Glamor.createElement(
	        "div",
	        null,
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { to: this.props.permalink },
	          Glamor.createElement(
	            "div",
	            { css: _globalStyles2.default.placeholder },
	            Glamor.createElement("img", { src: this.props.icon })
	          ),
	          Glamor.createElement(
	            "h5",
	            null,
	            _prismicDom2.default.RichText.asText(this.props.name)
	          )
	        ),
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { to: this.props.permalink },
	          Glamor.createElement(
	            "h2",
	            null,
	            _prismicDom2.default.RichText.asText(this.props.tagline)
	          )
	        ),
	        this.props.bullets.map(function (object, i) {
	          return Glamor.createElement(
	            "p",
	            { css: styles.info, key: i },
	            _prismicDom2.default.RichText.asText(object.feature_bullet)
	          );
	        }),
	        Glamor.createElement(
	          "div",
	          { css: _button.buttonGroupStyle.horizontalLeft },
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { css: [_button.buttonStyle.button, _button.buttonStyle.filled], to: this.props.permalink, style: !this.props.permalink ? { display: 'none' } : undefined },
	            "Learn more about ",
	            _prismicDom2.default.RichText.asText(buttonText)
	          ),
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { css: [_button.buttonStyle.button, _button.buttonStyle.outline], to: "/contact-us" },
	            "Book a demo"
	          )
	        )
	      ),
	      Glamor.createElement(
	        "div",
	        { css: [styles.mainFeatureGraphic, styles.normal] },
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { to: this.props.permalink },
	          Glamor.createElement("img", { src: this.props.image })
	        )
	      )
	    );
	  };
	
	  return FeatureHeaderLeft;
	}(_react2.default.Component);
	
	var styles = {
	  mainFeature: (_mainFeature = {
	    display: '-webkit-box'
	  }, _mainFeature["display"] = '-moz-box', _mainFeature["display"] = '-ms-flexbox', _mainFeature["display"] = '-webkit-flex', _mainFeature["display"] = 'flex', _mainFeature.alignItems = 'center', _mainFeature[_presets2.default.Desktop] = {
	    flexFlow: 'row',
	    paddingTop: '50px',
	    paddingBottom: '50px'
	  }, _mainFeature[_presets2.default.Tablet] = {
	    flexFlow: 'row',
	    paddingTop: '50px',
	    paddingBottom: '50px'
	  }, _mainFeature[_presets2.default.Mobile] = {
	    flexFlow: 'column'
	  }, _mainFeature),
	  grid: (_grid = {}, _grid[_presets2.default.Desktop] = {
	    maxWidth: '50%',
	    padding: '100px 0'
	  }, _grid[_presets2.default.Tablet] = {
	    maxWidth: '50%',
	    padding: '25px 0'
	  }, _grid[_presets2.default.Mobile] = {
	    padding: '50px 20px',
	    order: 1
	  }, _grid),
	  circle: (_circle = {}, _circle[_presets2.default.Desktop] = {
	    left: '200px',
	    marginLeft: '-100px'
	  }, _circle[_presets2.default.Tablet] = {
	    left: '200px',
	    marginLeft: '-100px'
	  }, _circle['& img'] = {
	    borderRadius: '100%',
	    '-webkit-box-shadow': 'inset 0px 0px 15px #888888',
	    '-moz-box-shadow': 'inset 0px 0px 15px #888888',
	    boxShadow: 'inset 0px 0px 15px #888888'
	  }, _circle),
	  frame: (_frame = {}, _frame[_presets2.default.Desktop] = {
	    left: '100px'
	  }, _frame[_presets2.default.Tablet] = {
	    left: '100px'
	  }, _frame),
	  normal: (_normal = {}, _normal[_presets2.default.Desktop] = {
	    left: '100px'
	  }, _normal[_presets2.default.Tablet] = {
	    left: '100px'
	  }, _normal),
	  info: (_info = {}, _info[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    width: '40%',
	    margin: '20px 10% 20px 0',
	    verticalAlign: 'top'
	  }, _info[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    width: '40%',
	    margin: '20px 10% 20px 0',
	    verticalAlign: 'top'
	  }, _info),
	  mainFeatureGraphic: (_mainFeatureGraphic = {}, _mainFeatureGraphic[_presets2.default.Desktop] = {
	    position: 'relative',
	    minWidth: '50%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic[_presets2.default.Tablet] = {
	    position: 'relative',
	    minWidth: '50%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic[_presets2.default.Mobile] = {
	    order: 0,
	    width: '100%',
	    maxWidth: '100%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic['& img'] = {
	    maxWidth: '100%'
	  }, _mainFeatureGraphic)
	};
	
	exports.default = FeatureHeaderLeft;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/feature-header-right.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _mainFeature, _grid, _circle, _frame, _normal, _info, _mainFeatureGraphic;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureHeaderRight = function (_React$Component) {
	  _inherits(FeatureHeaderRight, _React$Component);
	
	  function FeatureHeaderRight() {
	    _classCallCheck(this, FeatureHeaderRight);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  FeatureHeaderRight.prototype.render = function render() {
	
	    var buttonText = [{ type: this.props.name[0].type, text: this.props.name[0].text.toLowerCase() }];
	
	    return Glamor.createElement(
	      "div",
	      { css: styles.mainFeature },
	      Glamor.createElement(
	        "div",
	        { css: [styles.mainFeatureGraphic, styles.normal] },
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { to: this.props.permalink },
	          Glamor.createElement("img", { src: this.props.image })
	        )
	      ),
	      Glamor.createElement(
	        "div",
	        null,
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { to: this.props.permalink },
	          Glamor.createElement(
	            "div",
	            { css: _globalStyles2.default.placeholder },
	            Glamor.createElement("img", { src: this.props.icon })
	          ),
	          Glamor.createElement(
	            "h5",
	            null,
	            _prismicDom2.default.RichText.asText(this.props.name)
	          ),
	          Glamor.createElement(
	            "h2",
	            null,
	            _prismicDom2.default.RichText.asText(this.props.tagline)
	          )
	        ),
	        this.props.bullets.map(function (object, i) {
	          return Glamor.createElement(
	            "p",
	            { css: styles.info, key: i },
	            _prismicDom2.default.RichText.asText(object.feature_bullet)
	          );
	        }),
	        Glamor.createElement(
	          "div",
	          { css: _button.buttonGroupStyle.horizontalLeft },
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { css: [_button.buttonStyle.button, _button.buttonStyle.filled], to: this.props.permalink, style: !this.props.permalink ? { display: 'none' } : undefined },
	            "Learn more about ",
	            _prismicDom2.default.RichText.asText(buttonText)
	          ),
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { css: [_button.buttonStyle.button, _button.buttonStyle.outline], to: "/contact-us" },
	            "Book a demo"
	          )
	        )
	      )
	    );
	  };
	
	  return FeatureHeaderRight;
	}(_react2.default.Component);
	
	var styles = {
	  mainFeature: (_mainFeature = {
	    display: '-webkit-box'
	  }, _mainFeature["display"] = '-moz-box', _mainFeature["display"] = '-ms-flexbox', _mainFeature["display"] = '-webkit-flex', _mainFeature["display"] = 'flex', _mainFeature.alignItems = 'center', _mainFeature[_presets2.default.Desktop] = {
	    flexFlow: 'row',
	    paddingTop: '50px',
	    paddingBottom: '50px'
	  }, _mainFeature[_presets2.default.Tablet] = {
	    flexFlow: 'row',
	    paddingTop: '50px',
	    paddingBottom: '50px'
	  }, _mainFeature[_presets2.default.Mobile] = {
	    flexFlow: 'column'
	  }, _mainFeature),
	  grid: (_grid = {}, _grid[_presets2.default.Desktop] = {
	    maxWidth: '50%',
	    padding: '100px 0'
	  }, _grid[_presets2.default.Tablet] = {
	    maxWidth: '50%',
	    padding: '25px 0'
	  }, _grid[_presets2.default.Mobile] = {
	    padding: '50px 20px',
	    order: 1
	  }, _grid),
	  circle: (_circle = {}, _circle[_presets2.default.Desktop] = {
	    right: '200px',
	    marginRight: '-100px'
	  }, _circle[_presets2.default.Tablet] = {
	    right: '200px',
	    marginRight: '-100px'
	  }, _circle['& img'] = {
	    borderRadius: '100%',
	    '-webkit-box-shadow': 'inset 0px 0px 15px #888888',
	    '-moz-box-shadow': 'inset 0px 0px 15px #888888',
	    boxShadow: 'inset 0px 0px 15px #888888'
	  }, _circle),
	  frame: (_frame = {}, _frame[_presets2.default.Desktop] = {
	    right: '100px'
	  }, _frame[_presets2.default.Tablet] = {
	    right: '100px'
	  }, _frame),
	  normal: (_normal = {}, _normal[_presets2.default.Desktop] = {
	    right: '100px'
	  }, _normal[_presets2.default.Tablet] = {
	    right: '100px'
	  }, _normal),
	  info: (_info = {}, _info[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    width: '40%',
	    margin: '20px 10% 20px 0',
	    verticalAlign: 'top'
	  }, _info[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    width: '40%',
	    margin: '20px 10% 20px 0',
	    verticalAlign: 'top'
	  }, _info),
	  mainFeatureGraphic: (_mainFeatureGraphic = {}, _mainFeatureGraphic[_presets2.default.Desktop] = {
	    position: 'relative',
	    minWidth: '50%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic[_presets2.default.Tablet] = {
	    position: 'relative',
	    minWidth: '50%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic[_presets2.default.Mobile] = {
	    order: 0,
	    width: '100%',
	    maxWidth: '100%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic['& img'] = {
	    maxWidth: '100%'
	  }, _mainFeatureGraphic)
	};
	
	exports.default = FeatureHeaderRight;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/features/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _before, _after, _section, _column, _column2, _column2feature, _section2, _before2, _placeholder, _feature, _featureGrid, _section3;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	var _featureHeaderRight = __webpack_require__("./src/components/feature-header-right.js");
	
	var _featureHeaderRight2 = _interopRequireDefault(_featureHeaderRight);
	
	var _featureHeaderLeft = __webpack_require__("./src/components/feature-header-left.js");
	
	var _featureHeaderLeft2 = _interopRequireDefault(_featureHeaderLeft);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Features = function (_React$Component) {
	  _inherits(Features, _React$Component);
	
	  function Features() {
	    _classCallCheck(this, Features);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  Features.prototype.render = function render() {
	
	    var features = this.props.data.allPrismicDocument.edges;
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(_reactHelmet.Helmet, { title: 'Features' }),
	      Glamor.createElement(
	        'div',
	        { css: styles.section1 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'div',
	            { css: styles.column1 },
	            Glamor.createElement(
	              'h1',
	              { css: _globalStyles2.default.sectionTitleTop },
	              'Feature Highlights'
	            ),
	            Glamor.createElement(
	              'p',
	              { css: _globalStyles2.default.sectionDescriptionTop },
	              'Learn about the crucial parts of CarePlanner that will help boost your growth.'
	            ),
	            Glamor.createElement(
	              'div',
	              null,
	              Glamor.createElement(
	                'a',
	                { css: [_button.buttonStyle.button, _button.buttonStyle.outline], href: 'https://www.youtube.com/embed/7oTDpRya7Ko?autoplay=1', target: '_blank' },
	                'Watch the video'
	              ),
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { css: [_button.buttonStyle.button, _button.buttonStyle.filled], to: '/contact-us' },
	                'Book a demo'
	              )
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.column2 },
	            features.map(function (feature, i) {
	              return Glamor.createElement(
	                'h5',
	                { css: styles.column2feature, key: i },
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { to: feature.node.fields.permalink },
	                  _prismicDom2.default.RichText.asText(feature.node.data.feature_name)
	                )
	              );
	            })
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section2 },
	        features.map(function (featureEdge, i) {
	          var feature = featureEdge.node.data;
	          if (i % 2) {
	            return Glamor.createElement(_featureHeaderLeft2.default, {
	              key: i,
	              permalink: featureEdge.node.fields.permalink,
	              image: feature.feature_image.url,
	              icon: feature.feature_icon.url ? feature.feature_icon.url : __webpack_require__("./src/assets/feature-icon-placeholder.svg"),
	              name: feature.feature_name,
	              tagline: feature.feature_tagline,
	              bullets: feature.feature_bullets
	            });
	          } else {
	            return Glamor.createElement(_featureHeaderRight2.default, {
	              key: i,
	              permalink: featureEdge.node.fields.permalink,
	              image: feature.feature_image.url,
	              icon: feature.feature_icon.url ? feature.feature_icon.url : __webpack_require__("./src/assets/feature-icon-placeholder.svg"),
	              name: feature.feature_name,
	              tagline: feature.feature_tagline,
	              bullets: feature.feature_bullets
	            });
	          }
	        })
	      )
	    );
	  };
	
	  return Features;
	}(_react2.default.Component);
	
	exports.default = Features;
	;
	
	var styles = {
	  section1: (_section = {
	    position: 'relative'
	  }, _section[_presets2.default.Desktop] = {
	    padding: '100px'
	  }, _section[_presets2.default.Tablet] = {
	    padding: '100px'
	  }, _section[_presets2.default.Mobile] = {
	    marginBottom: '60px',
	    padding: '50px 25px'
	  }, _section['::before'] = (_before = {
	    content: '""',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    zIndex: -1,
	    opacity: .2,
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'top right',
	    backgroundImage: 'url(' + __webpack_require__("./src/assets/section-1.png") + ')'
	  }, _before[_presets2.default.Desktop] = {
	    height: '200%',
	    backgroundSize: '100%'
	  }, _before[_presets2.default.Tablet] = {
	    height: '200%',
	    backgroundSize: '100%'
	  }, _before[_presets2.default.Mobile] = {
	    height: '100%',
	    backgroundSize: 'cover'
	  }, _before), _section['::after'] = (_after = {
	    content: '""',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    zIndex: -1,
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover',
	    backgroundImage: '-webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)'
	  }, _after['backgroundImage'] = '-o-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _after['backgroundImage'] = '-moz-linear-gradient(bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _after['backgroundImage'] = 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 75%)', _after[_presets2.default.Desktop] = {
	    height: '200%'
	  }, _after[_presets2.default.Tablet] = {
	    height: '150%'
	  }, _after[_presets2.default.Mobile] = {
	    height: '100%'
	  }, _after), _section),
	  column1: (_column = {}, _column[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    maxWidth: '40%',
	    width: '40%',
	    margin: '0 1%'
	  }, _column[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    maxWidth: '50%',
	    width: '50%',
	    margin: '0 1%'
	  }, _column[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _column),
	  column2: (_column2 = {}, _column2[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    maxWidth: '48%',
	    width: '48%',
	    margin: '0 5%'
	  }, _column2[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    maxWidth: '38%',
	    width: '38%',
	    margin: '0 5%'
	  }, _column2[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _column2),
	  column2feature: (_column2feature = {}, _column2feature[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '50%',
	    width: '50%'
	  }, _column2feature[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '100%',
	    width: '100%'
	  }, _column2feature[_presets2.default.Mobile] = {
	    maxWidth: '100%',
	    width: '100%'
	  }, _column2feature),
	  section2: (_section2 = {}, _section2[_presets2.default.Desktop] = {
	    padding: '50px 100px 100px 100px'
	  }, _section2[_presets2.default.Tablet] = {
	    padding: '50px'
	  }, _section2[_presets2.default.Mobile] = {
	    marginBottom: '60px',
	    padding: '0 20px'
	  }, _section2),
	  section3: (_section3 = {
	    position: 'relative',
	    width: '100%',
	    backgroundColor: '#F4F8FC'
	  }, _section3[_presets2.default.Mobile] = {
	    top: '30%'
	  }, _section3['& h1'] = {
	    textAlign: 'center'
	  }, _section3['::before'] = (_before2 = {
	    content: '""',
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    height: '100%',
	    backgroundImage: 'url(' + __webpack_require__("./src/assets/curve-top.svg") + ')',
	    backgroundRepeat: 'no-repeat',
	    backgroundPositionY: 'top',
	    backgroundPositionX: 'center',
	    zIndex: -1
	  }, _before2[_presets2.default.Desktop] = {
	    top: '-30%',
	    backgroundSize: 'cover'
	  }, _before2[_presets2.default.Tablet] = {
	    top: '-129px',
	    backgroundSize: 'contain'
	  }, _before2[_presets2.default.Mobile] = {
	    top: '-125px',
	    backgroundSize: 'contain'
	  }, _before2), _section3.featureGrid = (_featureGrid = {}, _featureGrid[_presets2.default.Desktop] = {
	    padding: '50px 100px'
	  }, _featureGrid[_presets2.default.Tablet] = {
	    padding: '50px 100px'
	  }, _featureGrid[_presets2.default.Mobile] = {
	    padding: '50px 20px'
	  }, _featureGrid.feature = (_feature = {}, _feature[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '20%',
	    width: '20%',
	    margin: '40px 2%'
	  }, _feature[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '25%',
	    width: '25%',
	    margin: '40px 3.5%'
	  }, _feature[_presets2.default.Mobile] = {
	    margin: '40px 15px'
	  }, _feature.placeholder = (_placeholder = {}, _placeholder[_presets2.default.Mobile] = {
	    float: 'left',
	    marginRight: '25px'
	  }, _placeholder), _feature), _featureGrid), _section3)
	
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-index-js-a0b5b4f8a54446ee2f8d.js